import React from "react";

const CartButtonOptions = ({
    cartButtons,
    editButtonData,
    setEditButtonData,
    handleSaveEdit,
}) => {
    return (
        <div className="setting-cart-container">
            {editButtonData && (
                <div className="setting-cart-modal">

                    <div className="setting-cart-modal-content">
                        <h3 className="setting-payment-modal-title">Edit Cart Button</h3>
                        <label>Button Name</label>
                        <input
                            type="text"
                            value={editButtonData.button}
                            onChange={(e) =>
                                setEditButtonData({ ...editButtonData, button: e.target.value })
                            }
                        />
                        <label className="setting-cart-checkbox-label">
                            <input
                                type="checkbox"
                                checked={editButtonData.default}
                                onChange={(e) =>
                                    setEditButtonData({
                                        ...editButtonData,
                                        default: e.target.checked,
                                    })
                                }
                            />
                            Set as Default
                        </label>
                        <div className="setting-cart-modal-actions">
                            <button onClick={handleSaveEdit} className="setting-cart-btn-save">
                                Save
                            </button>
                            <button
                                onClick={() => setEditButtonData(null)}
                                className="setting-cart-btn-cancel"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <table className="setting-payment-table">
                <thead>
                    <tr>
                        <th>Button Name</th>
                        <th>Default</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {cartButtons.map((btn) => (
                        <tr key={btn.id}>
                            <td>{btn.button}</td>
                            <td>{btn.default ? "Yes" : "No"}</td>
                            <td>
                                <button
                                    className="setting-cart-edit-btn"
                                    onClick={() => setEditButtonData({ ...btn })}
                                >
                                    <i className="fa-solid fa-pencil"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CartButtonOptions;
